import SecondaryLeftNavigation from '@/components/SecondaryLeftNavigation'
import { useDocumentPreviewOptional } from '@/features/documentPreview/useDocumentPreview.js'

export function AppShellSecondaryNavSlot({ secondaryNavProps }) {
  const preview = useDocumentPreviewOptional()
  return <SecondaryLeftNavigation {...secondaryNavProps} collapsedForRail={preview?.isOpen} />
}
